import {ColonistMembershipType, ColonistOneTimePurchaseType, LobbyImage} from '@colonist/types'
import {ColonistMembershipProduct, MobileMembershipIAPSKUIds, PerkAllColors, PerkAllExpansions, PerkAllMaps, PerkBasicReplay, PerkFullReplay, PerkNoAds, PerkRankedGames} from './ColonistMembershipProduct'

export class ColonistGiftMembershipProduct extends ColonistMembershipProduct {
    static products: Map<ColonistMembershipType, ColonistMembershipProduct> = new Map()

    static override getAllMembershipProducts(): ColonistMembershipProduct[] {
        return Array.from(this.products.values())
    }

    static override initProducts(stripePriceIds: Record<string, string>, discordSKUIds: Record<string, string>): void {
        const giftPlusMonthlyProduct = new ColonistMembershipProduct({
            type: ColonistMembershipType.PlusMonthly,
            price: 899,
            stripePriceId: stripePriceIds.giftMembershipPlus,
            discordSKUId: discordSKUIds.giftMembershipPlus,
            membershipTitle: {key: 'strings:storePage.membership.title.plus'},
            membershipColor: 'membership_type1',
            lobbyImage: LobbyImage.StoreMembershipPlus,
            perks: [new PerkRankedGames(), new PerkNoAds(), new PerkBasicReplay()],
            billedAnnually: false,
            bestValue: false,
            mobileIAPSKUId: MobileMembershipIAPSKUIds.PlusMonthly,
            discount: 0,
            isActive: () => true,
        })
        giftPlusMonthlyProduct.oneTimePurchaseType = ColonistOneTimePurchaseType.GiftPlusMonthly
        this.products.set(ColonistMembershipType.PlusMonthly, giftPlusMonthlyProduct)

        const giftPremiumMonthlyProduct = new ColonistMembershipProduct({
            type: ColonistMembershipType.PremiumMonthly,
            price: 1899,
            stripePriceId: stripePriceIds.giftMembershipPremium,
            discordSKUId: discordSKUIds.giftMembershipPremium,
            mobileIAPSKUId: MobileMembershipIAPSKUIds.PremiumMonthly,
            membershipTitle: {key: 'strings:storePage.membership.title.premium'},
            membershipColor: 'membership_type2',
            lobbyImage: LobbyImage.StoreMembershipPremium,
            perks: [new PerkRankedGames(), new PerkNoAds(), new PerkFullReplay(), new PerkAllExpansions(), new PerkAllMaps()],
            billedAnnually: false,
            bestValue: true,
            discount: 0,
            isActive: () => true,
        })
        giftPremiumMonthlyProduct.oneTimePurchaseType = ColonistOneTimePurchaseType.GiftPremiumMonthly
        this.products.set(ColonistMembershipType.PremiumMonthly, giftPremiumMonthlyProduct)

        const giftEliteMonthlyProduct = new ColonistMembershipProduct({
            type: ColonistMembershipType.EliteMonthly,
            price: 2499,
            stripePriceId: stripePriceIds.giftMembershipElite,
            discordSKUId: discordSKUIds.giftMembershipElite,
            mobileIAPSKUId: MobileMembershipIAPSKUIds.EliteMonthly,
            membershipTitle: {key: 'strings:storePage.membership.title.elite'},
            membershipColor: 'membership_type3',
            lobbyImage: LobbyImage.StoreMembershipElite,
            perks: [new PerkRankedGames(), new PerkNoAds(), new PerkFullReplay(), new PerkAllExpansions(), new PerkAllMaps(), new PerkAllColors()],
            billedAnnually: false,
            bestValue: false,
            discount: 0,
            isActive: () => true,
        })
        giftEliteMonthlyProduct.oneTimePurchaseType = ColonistOneTimePurchaseType.GiftEliteMonthly
        this.products.set(ColonistMembershipType.EliteMonthly, giftEliteMonthlyProduct)

        const giftPlusYearlyProduct = new ColonistMembershipProduct({
            type: ColonistMembershipType.PlusYearly,
            price: 8388,
            stripePriceId: stripePriceIds.giftMembershipPlusYearly,
            discordSKUId: discordSKUIds.giftMembershipPlusYearly,
            mobileIAPSKUId: MobileMembershipIAPSKUIds.PlusYearly,
            membershipTitle: {key: 'strings:storePage.membership.title.plus'},
            membershipColor: 'membership_type1',
            lobbyImage: LobbyImage.StoreMembershipPlus,
            perks: [new PerkRankedGames(), new PerkNoAds(), new PerkBasicReplay()],
            billedAnnually: false,
            bestValue: false,
            discount: 24,
            isActive: () => true,
        })
        giftPlusYearlyProduct.oneTimePurchaseType = ColonistOneTimePurchaseType.GiftPlusYearly
        this.products.set(ColonistMembershipType.PlusYearly, giftPlusYearlyProduct)

        const giftPremiumYearlyProduct = new ColonistMembershipProduct({
            type: ColonistMembershipType.PremiumYearly,
            price: 17988,
            stripePriceId: stripePriceIds.giftMembershipPremiumYearly,
            discordSKUId: discordSKUIds.giftMembershipPremiumYearly,
            mobileIAPSKUId: MobileMembershipIAPSKUIds.PremiumYearly,
            membershipTitle: {key: 'strings:storePage.membership.title.premium'},
            membershipColor: 'membership_type2',
            lobbyImage: LobbyImage.StoreMembershipPremium,
            perks: [new PerkRankedGames(), new PerkNoAds(), new PerkFullReplay(), new PerkAllExpansions(), new PerkAllMaps()],
            billedAnnually: false,
            bestValue: true,
            discount: 48,
            isActive: () => true,
        })

        giftPremiumYearlyProduct.oneTimePurchaseType = ColonistOneTimePurchaseType.GiftPremiumYearly
        this.products.set(ColonistMembershipType.PremiumYearly, giftPremiumYearlyProduct)

        const giftEliteYearlyProduct = new ColonistMembershipProduct({
            type: ColonistMembershipType.EliteYearly,
            price: 23988,
            stripePriceId: stripePriceIds.giftMembershipEliteYearly,
            discordSKUId: discordSKUIds.giftMembershipEliteYearly,
            mobileIAPSKUId: MobileMembershipIAPSKUIds.EliteYearly,
            membershipTitle: {key: 'strings:storePage.membership.title.elite'},
            membershipColor: 'membership_type3',
            lobbyImage: LobbyImage.StoreMembershipElite,
            perks: [new PerkRankedGames(), new PerkNoAds(), new PerkFullReplay(), new PerkAllExpansions(), new PerkAllMaps(), new PerkAllColors()],
            billedAnnually: false,
            bestValue: false,
            discount: 60,
            isActive: () => true,
        })

        giftEliteYearlyProduct.oneTimePurchaseType = ColonistOneTimePurchaseType.GiftEliteYearly
        this.products.set(ColonistMembershipType.EliteYearly, giftEliteYearlyProduct)
    }
}
